import { useState } from "react";
import { Button } from "./ui/button";
import { MessageSquare, Mic, Sparkles, X } from "lucide-react";
import VoiceCommand from "./VoiceCommand";
import AIChatPanel from "./AIChatPanel";

export default function AIAssistant({
  onSearch, 
  onFilterPriority, 
  onFilterStatus, 
  onFilterSystem,
  onFilterCountry,
  onClearFilters,
  onCreateTask,
  onExportPdf,
  onShowStats,
  className = ""
}) {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {/* Voice Command Button */}
      <VoiceCommand
        onSearch={onSearch}
        onFilterPriority={onFilterPriority}
        onFilterStatus={onFilterStatus}
        onFilterSystem={onFilterSystem}
        onFilterCountry={onFilterCountry}
        onClearFilters={onClearFilters}
        onCreateTask={onCreateTask}
        onExportPdf={onExportPdf}
        onShowStats={onShowStats}
      />
      
      {/* Chat Toggle Button */}
      <Button
        variant={chatOpen ? "default" : "outline"}
        size="icon"
        onClick={() => setChatOpen(!chatOpen)}
        className={chatOpen ? "bg-primary" : ""}
        data-testid="ai-chat-toggle"
        title="Chat AI"
      >
        {chatOpen ? (
          <X className="w-4 h-4" />
        ) : (
          <div className="relative">
            <MessageSquare className="w-4 h-4" />
            <Sparkles className="w-2 h-2 absolute -top-1 -right-1 text-yellow-500" />
          </div>
        )}
      </Button>
      
      {/* Chat Panel */}
      <AIChatPanel
        isOpen={chatOpen}
        onClose={() => setChatOpen(false)}
        onSearch={onSearch}
        onFilterPriority={onFilterPriority}
        onFilterStatus={onFilterStatus}
        onFilterSystem={onFilterSystem}
        onFilterCountry={onFilterCountry}
        onClearFilters={onClearFilters}
        onCreateTask={onCreateTask}
        onExportPdf={onExportPdf}
      />
    </div>
  );
}
